export default __webpack_public_path__ + "static/media/characters.e3a0336f.png";